// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3UkE3","itemTitle":"ClientEmergencyInfo_itemTitle___YeMQ","itemText":"ClientEmergencyInfo_itemText__1YJ83"};